<template>
  <div
    class="fixed inset-0 z-[110] flex items-center justify-center bg-ink/50 px-4"
  >
    <div ref="dialogPanel" role="dialog" aria-modal="true" :aria-labelledby="dialogTitleId" tabindex="-1" @keydown="onDialogKeydown" class="w-full max-w-xs paper-card rounded-md p-5">
      <p :id="dialogTitleId" class="text-[14px] font-semibold mb-1.5">{{ title }}</p>
      <p v-if="message" class="text-[12.5px] text-ink2 leading-snug mb-4">{{ message }}</p>
      <div class="flex gap-2" :class="{ 'mt-4': !message }">
        <button
          type="button"
          @click="$emit('cancel')"
          class="flex-1 h-9 rounded-md border border-border text-[12.5px] font-semibold hover:bg-[hsl(var(--muted))] transition-colors"
        >{{ cancelLabel }}</button>
        <button
          type="button"
          :disabled="loading"
          @click="$emit('confirm')"
          class="flex-1 h-9 rounded-md text-white text-[12.5px] font-semibold transition-colors disabled:opacity-60 flex items-center justify-center gap-1.5"
          :class="danger ? 'bg-[hsl(var(--danger))] hover:bg-[hsl(0,65%,45%)]' : 'bg-[hsl(var(--primary))] hover:bg-[hsl(158,38%,30%)]'"
        >
          <Loader2 v-if="loading" class="w-3.5 h-3.5 animate-spin" />
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useDialogA11y } from "../composables/useDialogA11y";
import { Loader2 } from "lucide-vue-next";

withDefaults(
  defineProps<{
    title: string;
    message?: string;
    confirmLabel: string;
    cancelLabel: string;
    danger?: boolean;
    loading?: boolean;
  }>(),
  { danger: false, loading: false }
);

const emit = defineEmits<{
  (e: "confirm"): void;
  (e: "cancel"): void;
}>();

// Доступность окна: ловушка фокуса, Esc, возврат фокуса (useDialogA11y).
const dialogPanel = ref<HTMLElement | null>(null);
const { titleId: dialogTitleId, onKeydown: onDialogKeydown } = useDialogA11y(dialogPanel, { onClose: () => emit('cancel') });
</script>
